import React from 'react';
import { Coffee } from 'lucide-react';

const SipSessions = () => {
  const videos = [
    { id: 'nhA8I1ydNSo', title: 'SIP Session: Brand Strategy Analysis Episode 1' },
    { id: 'QlzE4mNgCpY', title: 'SIP Session: Brand Strategy Analysis Episode 2' },
    { id: 'UtS2jJWMyhg', title: 'SIP Session: Brand Strategy Analysis Episode 3' },
  ];

  return (
    <section className="py-8 md:py-12 bg-white" aria-labelledby="sip-sessions-heading">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-4 md:mb-6">
          <div className="flex justify-center mb-2">
            <Coffee className="w-5 h-5 md:w-6 md:h-6 text-stone-500" aria-hidden="true" />
          </div>
          <h2 id="sip-sessions-heading" className="text-base md:text-lg font-bold text-stone-800 mb-1">
            SIP sessions
          </h2>
          <p className="text-sm md:text-base text-stone-600 max-w-md mx-auto">
            <span className="font-semibold">Strategize in Public</span> — my way of thinking out loud
            <br />
            &amp; analyzing brands that inspire me
          </p>
        </div>

        {/* Video grid */}
        <div 
          className="flex gap-3 md:gap-4 overflow-x-auto pb-2 md:pb-0 md:justify-center md:overflow-visible snap-x snap-mandatory"
          role="list"
          aria-label="SIP Sessions video playlist"
        >
          {videos.map((video, index) => (
            <div 
              key={video.id} 
              className="flex-shrink-0 w-[280px] md:w-[300px] aspect-video rounded-lg overflow-hidden shadow-md bg-stone-900 snap-center"
              role="listitem"
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
        
        {/* Screen reader announcement for horizontal scroll */}
        <p className="sr-only">
          Scroll horizontally to view more videos on mobile devices
        </p>
      </div>
    </section>
  );
};

export default SipSessions;
